import { api } from '../../service';
import type { HasActiveSubscriptionResponse, SubscriptionInfoResponse } from 'api/types';

/**
 * Verifica si el usuario tiene una suscripción activa para el concurso
 * @param user_id - El ID del usuario
 * @param contest_id - El ID del concurso
 * @returns Promise con la respuesta que indica si tiene suscripción activa
 */
export async function hasActiveSubscription_api(user_id: number, contest_id: number): Promise<HasActiveSubscriptionResponse> {
  const { data } = await api.get('/contest-subscription/has-active-subscription', {
    params: { user_id, contest_id },
  });
  return data;
}

/**
 * Obtiene información completa de la suscripción del usuario para el concurso
 * @param user_id - El ID del usuario
 * @param contest_id - El ID del concurso
 * @returns Promise con la información completa de la suscripción
 */
export async function getSubscriptionInfo_api(user_id: number, contest_id: number): Promise<SubscriptionInfoResponse> {
  const { data } = await api.get('/contest-subscription/subscription-info', {
    params: { user_id, contest_id },
  });
  return data;
}

/**
 * Elimina una suscripción pendiente para permitir crear una nueva
 * @param user_id - El ID del usuario
 * @param contest_id - El ID del concurso
 * @returns Promise con la respuesta que indica si se eliminó la suscripción
 */
export async function deletePendingSubscription_api(user_id: number, contest_id: number): Promise<{ deleted: boolean }> {
  const { data } = await api.post(
    '/contest-subscription/delete-pending',
    {},
    {
      params: { user_id, contest_id },
    },
  );
  return data;
}

export async function deleteSubscription_api(subscriptionId: number): Promise<{ deleted: boolean }> {
  const { data } = await api.delete(`/contest-subscription/admin/${subscriptionId}`);
  return data;
}

export const contestSubscriptionService = {
  hasActiveSubscription_api,
  getSubscriptionInfo_api,
  deletePendingSubscription_api,
  deleteSubscription_api,
};
